import { getInvivoSceneManifest, loadInvivoSceneManifest } from "./invivo_manifest";
import { normalizeLegacyScene } from "../legacy_compat/normalize_legacy_scene";
import type { NormalizedScenePackage } from "../types/invivo_scene";

export type InvivoScenePackage = NormalizedScenePackage;

export async function createInvivoScenePackage({
  appUrl = window.location.href,
  fetchImpl = fetch,
  sceneSlug,
}: {
  appUrl?: string;
  fetchImpl?: typeof fetch;
  sceneSlug?: string;
} = {}): Promise<InvivoScenePackage> {
  const sceneManifest = await loadInvivoSceneManifest({ fetchImpl });
  const manifest = getInvivoSceneManifest({ manifest: sceneManifest, slug: sceneSlug });
  return normalizeLegacyScene({ manifest, appUrl });
}
